import { CHAIN_ID } from '../constants'

export function useChainId() {
  return { chainId: CHAIN_ID }
}
